import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  position: relative;
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
